/**
 * ProductDocuments class
 * Subscribes to variant changes and re-renders the document list for the
 * selected variant, so documents sourced from variant metafields stay in sync.
 * The documents block lives outside the main product section, so it is not
 * covered by the block swapping done in variant-selects.
 */
if (!customElements.get("product-documents")) {
  customElements.define(
    "product-documents",
    class ProductDocuments extends HTMLElement {
      variantChangeUnsubscriber = undefined;
      abortController = undefined;

      connectedCallback() {
        if (!this.dataset.url || !this.dataset.section) return;

        // Subscribe to variant changes
        this.variantChangeUnsubscriber = webvista.subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            const variantId = event.data?.variant?.id;
            if (!variantId || `${variantId}` === this.dataset.variantId) return;

            this.renderDocuments(variantId);
          },
        );
      }

      disconnectedCallback() {
        this.abortController?.abort();
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      /**
       * Re-fetch this section for the given variant and swap in its file list.
       * @param {number|string} variantId - Id of the newly selected variant
       */
      renderDocuments(variantId) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        webvista
          .fetchHtml(
            `${this.dataset.url}?variant=${variantId}&section_id=${this.dataset.section}`,
            this.abortController.signal,
          )
          .then((html) => {
            const target = this.querySelector(".file-items");
            const source = html
              .getElementById(this.id)
              ?.querySelector(".file-items");
            if (!target || !source) return;

            target.innerHTML = source.innerHTML;
            this.dataset.variantId = variantId;
          })
          .catch((error) => {
            if (error.name === "AbortError") return;

            webvista.popToast(
              window["accessibilityStrings"]["unknownError"],
              "error",
            );
          });
      }
    },
  );
}
